module.exports = __webpack_public_path__ + "static/img/battery.bf89fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/battery.png
// module id = 416
// module chunks = 0